import * as React from "react";
import type { SVGProps } from "react";
const SvgRefreshCw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M24 4a1 1 0 1 0-2 0zm-1 6v1a1 1 0 0 0 1-1zm-6-1a1 1 0 1 0 0 2zM0 20a1 1 0 1 0 2 0zm1-6v-1a1 1 0 0 0-1 1zm6 1a1 1 0 1 0 0-2zM2.567 8.666a1 1 0 0 0 1.886.668zM18.36 5.64l-.707.707.022.022zM5.64 18.36l.707-.707-.022-.022zm15.793-3.026a1 1 0 1 0-1.886-.668zM22 4v6h2V4zm1 5h-6v2h6zM2 20v-6H0v6zm-1-5h6v-2H1zm3.453-5.666A8 8 0 0 1 6.68 6.023L5.35 4.528a10 10 0 0 0-2.784 4.138zM6.68 6.023A8 8 0 0 1 10.229 4.2l-.441-1.951A10 10 0 0 0 5.35 4.528zM10.229 4.2a8 8 0 0 1 3.988.117l.556-1.92a10 10 0 0 0-4.985-.148zm3.988.117a8 8 0 0 1 3.436 2.03l1.414-1.414a10 10 0 0 0-4.294-2.537zm3.458 2.052 4.64 4.36 1.37-1.458-4.64-4.36zm-17.36 8.36 4.64 4.36 1.37-1.458-4.64-4.36zm4.618 4.338a10 10 0 0 0 4.294 2.537l.556-1.921a8 8 0 0 1-3.436-2.03zm4.294 2.537a10 10 0 0 0 4.985.147l-.441-1.95a8 8 0 0 1-3.988-.118zm4.985.147a10 10 0 0 0 4.437-2.279l-1.329-1.495a8 8 0 0 1-3.549 1.823zm4.437-2.279a10 10 0 0 0 2.784-4.138l-1.886-.668a8 8 0 0 1-2.227 3.311z"
    />
  </svg>
);
export default SvgRefreshCw;
